const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
export const ADDRESS_HOST =
  currentEnv !== 'prod'
    ? 'https://geo.qa.layer.col.movistar.es'
    : 'https://geo.layer.col.movistar.es';
export const FAMILY_API = 'abs-layer';
export const PROCESS_NAME = 'ADABYRON-API';
